import { HttpErrorResponse } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { AppErrorHandlerService } from '../../services/app-error-handler/app-error-handler.service'
import { LogService } from '../../services/log.service'
import * as FeatureMYPActions from './feature-myp.actions'
import { FeatureMYPService } from './feature-myp.service'
import { UtilityService } from '../../services/utility.service'

@Injectable()
export class FeatureMYPEffects {
   private _cn = this.constructor.name
   private _actions$ = inject(Actions)
   private _logService = inject(LogService)
   private _service = inject(FeatureMYPService)
   private _utilityService = inject(UtilityService)
   private _errorHandlerService = inject(AppErrorHandlerService)

   actionSearchProject$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeatureMYPActions.searchYourProjects),
         switchMap((action) =>
            this._service.search(action.request).pipe(
               tap((res) => this._logService.debug(this._cn, 'loadStatutes effect', 'response:', res)),
               map((result) => FeatureMYPActions.searchYourProjectsSuccess({ result })),
               catchError((error: HttpErrorResponse) => {
                  return of(FeatureMYPActions.searchYourProjectsFailure({ error: error }))
               })
            )
         )
      )
   )

   exportExcelResults$ = createEffect(() =>
      this._actions$.pipe(
         ofType(FeatureMYPActions.exportExcelResults),
         switchMap((action) =>
            this._service.exportExcelResults(action.searchFields).pipe(
               tap((res) => this._logService.debug(this._cn, 'exportExcelResults effect', 'response:', res)),
               map((response) => {
                  if (response.body) {
                     this._utilityService.downloadFile(response)
                     return FeatureMYPActions.exportExcelResultsSuccess()
                  } else {
                     return FeatureMYPActions.exportExcelResultsFailure({ error: new HttpErrorResponse({ error: '0 - No blob in response to download' }) })
                  }
               }),

               catchError((error: HttpErrorResponse) => {
                  return of(FeatureMYPActions.exportExcelResultsFailure({ error: error }))
               })
            )
         )
      )
   )

   private _actionsForErrorNotificationMessage = [FeatureMYPActions.searchYourProjectsFailure, FeatureMYPActions.exportExcelResultsFailure]

   listenAllFailureAction$ = createEffect(
      () =>
         this._actions$.pipe(
            ofType(...this._actionsForErrorNotificationMessage),
            map((errorResponse) => this._errorHandlerService.handleError(errorResponse.error))
         ),
      { dispatch: false }
   )
}
